<template>
	<div v-if="projectData.contestId" class="project">

		<v-layout justify-end mr-3 class="no-print">
			<v-btn @click="printBudget()">Wydrukuj budżet</v-btn>
			<v-btn @click="printSchedule()">Wydrukuj harmonogram</v-btn>
			<v-btn @click="printActivities()">Wydrukuj opis działań</v-btn>
			<v-btn @click="exportTables">Eksportuj tabele finansowe</v-btn>
			<v-btn @click="print">Wydrukuj projekt</v-btn>
		</v-layout>

		<project-name
			v-model="projectData.title"
			:readonly="true"
		></project-name>

		<project-general-data :project-data="projectData" :contest-configuration="contestConfiguration"/>

		<project-english-name-read-only-view
			v-model="projectData.englishTitle"
			ref="englishName"
			:readonly="true"
		></project-english-name-read-only-view>

		<project-priority-tree-read-only-view
			v-if="projectData.contestId"
			:contest-id="projectData.contestId"
			v-model="projectData.prioritiesData"
		></project-priority-tree-read-only-view>

		<choose-funding
			class="choose-founding"
			ref="funding"
			v-if="projectData.contestId"
			:contest-id="projectData.contestId"
			:input="projectData.prioritiesData"
			v-model="projectData.financesData"
			:countries-changed.sync="countriesChanged"
			:readonly="true"
		></choose-funding>

		<choose-d-a-c
			v-if="projectData.contestId && contestConfiguration.dacCodesEnabled"
			:contest-id="projectData.contestId"
			type="PUBLIC_CONTEST"
			ref="chooseDac"
			v-model="projectData.dacCodes"
			:readonly="true"
		></choose-d-a-c>

		<project-choose-start-end-read-only-view
			v-model="projectData.dates"
			ref="startEnd"
		></project-choose-start-end-read-only-view>

		<project-choose-volunteers-read-only-view
			v-if="contestConfiguration.volunteersAvailable"
			v-model="projectData.volunteers"
			:volunteers-required="contestConfiguration.volunteersRequired"
			:global-init="projectData.globalInitiative"
			:global-init-description="projectData.globalInitiativeDescription"
			ref="volunteers"
		></project-choose-volunteers-read-only-view>

		<project-choose-actions-read-only-view
			v-model="projectData.actionsData"
			:contest-id="projectData.contestId"
			ref="actions"
		></project-choose-actions-read-only-view>

		<project-choose-geographical-location-read-only-view
			v-model="projectData.locations"
			ref="locations"
		></project-choose-geographical-location-read-only-view>

		<project-costs-calculated-table
			:actions="projectData.actionsData"
			:costs="projectData.actionsCosts"
			:administrative="projectData.administrativeCosts"
			ref="costsCalculatedTable-1"
		/>

		<ProjectCostsSummaryTable
			v-if="projectData.contestId"
			:costs="projectData.actionsCosts"
			:administrative="projectData.administrativeCosts"
			:offer-configuration="contestConfiguration"
			:main-country-id="projectData.prioritiesData.mainCountryId"
			:main-bidder-id="projectData.mainBidderId"
			:contest-id="projectData.contestId"
			ref="costsSummaryTable-1"
		></ProjectCostsSummaryTable>

		<ProjectBidderFundingsTable
			class="mt-4 read-only-costs-sharing"
			:readonly="true"
			:costs="projectData.actionsCosts"
			:administrative="projectData.administrativeCosts"
			:fundings="projectData.bidderFundings"
			:mutual="projectData.mutualProject"
			ref="bidderFundings"
			:show-print-info="false"
		></ProjectBidderFundingsTable>

		<contest-offer-timetable
			class="d-none print-only"
			:actions="projectData.actionsData"
		></contest-offer-timetable>
		<div v-for="(section, index) in genericMap" v-bind:key="index">
			<vue-form-generator
				:disabled="true"
				:name="'generator-'.concat(index)"
				:model="section.model"
				:schema="section.schema"
			/>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import ChooseDAC from "../offer/components/ChooseDAC";
	import ChooseFunding from "../offer/components/ChooseFunding";
	import ContestOfferTimetable from "../offer/components/ContestOfferTimetable";
	import VueFormGenerator from "vue-form-generator";
  import ProjectBidderFundingsTable from "./components/ProjectBidderFundingsTable";
	import ProjectCostsSummaryTable from "./components/ProjectCostsSummaryTable";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import ProjectName from "./components/ProjectName";
	import ProjectGeneralData from "./components/ProjectGeneralData";
	import {Dates} from "@/utils/Dates";
	import {Files} from "@/utils/Files";
	import {CostsUtils} from "@/utils/CostsUtils";
	import {XlsExport} from "@/api/generated/XlsExport";
	import ProjectEnglishNameReadOnlyView from "./readOnlyComponents/ProjectEnglishNameReadOnlyView";
	import ProjectPriorityTreeReadOnlyView from "./readOnlyComponents/ProjectPriorityTreeReadOnlyView";
	import ProjectChooseStartEndReadOnlyView from "./readOnlyComponents/ProjectChooseStartEndReadOnlyView";
	import ProjectChooseVolunteersReadOnlyView from "./readOnlyComponents/ProjectChooseVolunteersReadOnlyView";
	import ProjectChooseActionsReadOnlyView from "./readOnlyComponents/ProjectChooseActionsReadOnlyView";
	import ProjectChooseGeographicalLocationReadOnlyView
		from "./readOnlyComponents/ProjectChooseGeographicalLocationReadOnlyView";
  import ProjectCostsCalculatedTable from "@/view/logged/project/components/ProjectCostsCalculatedTable";

	Vue.use(VueFormGenerator);

	export default {
		name: "ProjectReadOnlyView",

		components: {
      ProjectCostsCalculatedTable,
			ProjectChooseGeographicalLocationReadOnlyView,
			ProjectChooseActionsReadOnlyView,
			ProjectChooseVolunteersReadOnlyView,
			ProjectChooseStartEndReadOnlyView,
			ProjectPriorityTreeReadOnlyView,
			ProjectEnglishNameReadOnlyView,
			ProjectGeneralData,
			ProjectName,
      ProjectBidderFundingsTable,
      ProjectCostsSummaryTable,
			ChooseDAC,
			ChooseFunding,
			ContestOfferTimetable,
		},

		computed: {
			stepTitle() {
				return this.viewData.titles[this.viewData.step - 1];
			},

			totalNumberOfSteps() {
				return 8;
			},

			isFirstStep() {
				return this.viewData.step === 1;
			},

			isLastStep() {
				return this.viewData.step === this.totalNumberOfSteps;
			},
			genericMap() {
				if (this.contestConfiguration.persistentSchema === null || this.projectData.genericModel === null) {
					return null;
				} else {
					let sectionsArray = [];
					for (let i = 0; i < this.contestConfiguration.persistentSchema.sections.length; i++) {
						if (!genericFormUtil.sectionShouldNotBeOnView(this.contestConfiguration.persistentSchema, i)
							&& this.projectData.genericModel.sections[i]) {
							sectionsArray.push(
								{
									schema: this.applyGenericPersistentForm(i),
									model: this.projectData.genericModel.sections[i].fields,
								},
							);
						}
					}
					return sectionsArray;
				}
			},
		},

		data() {
			return {
				contestConfiguration: {
					numberOfModules: 0,
					persistentSchema: null,
					firstPossibleOfferDate: "",
					lastPossibleOfferDate: "",
					volunteersAvailable: undefined,
					volunteersRequired: undefined
				},
				countriesChanged: false,
				projectId: this.$route.params.projectId,
				projectData: {
					prioritiesData: {
						selected: [],
					},
				},
				viewData: {
					step: 1,
					titles: ["Podstawowe informacje", "Statystyka", "Ramy czasowe", "Działania programowe", "Koszty", "Podsumowanie kosztów", "Harmonogram", "Dane Generyczne", ""],
					sendOfferDialog: false,
					completeOfferDialog: false,
				},
				formGenerator: {
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalBooleans: [],
				},
				projectConfiguration: {},
			};
		},

		created() {
			this.loadData();
		},

		methods: {
			applyGenericPersistentForm(sectionIndex) {
				let sections = this.projectData.genericModel.sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
				} else {
					return schema;
				}
			},

			validateExistingRef(name) {
				if (this.$refs[name] === undefined) {
					return true;
				}
				if (typeof this.$refs[name]["validate"] !== "function") {
					return true;
				}
				let res = this.$refs[name].validate();
				return res;
			},

			async loadData() {
				await Api.syncGet(this, "/project/configuration?projectId=".concat(this.projectId), response => {
						this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.genericPartScheme);
						this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
						this.contestConfiguration.volunteersRequired = response.volunteersRequired;
						this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji projektu!", errorResponse),
				);
				// Pobranie danych projektu
				let path;
				if (this.$route.params.version) {
					path = "/project/data-version?projectId=".concat(this.projectId).concat("&version=".concat(this.$route.params.version));
				} else {
					path = "/project/readonly?projectId=".concat(this.projectId);
				}
				await Api.syncGet(
					this,
					path,
					response => {
						this.projectData = response;
						this.viewData.step = response.step;
						this.projectData.genericModel = genericFormUtil.decodeSchema(response.genericModel);
					});
				if (!this.genericMap) return;
				this.genericMap.forEach(function (section, index) {
					genericFormUtil.addHeaderToFirstForm(
						"generator-".concat(index.toString()),
						"<h2 style=\"margin-left: 20px; page-break-after: avoid\">" + this.contestConfiguration.persistentSchema.sections[index].name + "</h2>",
					);
				}, this);
			},

			nextStep() {
				let valid = this.validateNonGeneric();
				if (!valid) {
					return;
				}
				this.viewData.step = this.viewData.step + 1;
				this.projectData.step = this.viewData.step;
				this.changingStepAction();
			},

			stepBack() {
				this.viewData.step = this.viewData.step - 1;
				this.projectData.step = this.viewData.step;
				this.changingStepAction();
			},

			changeCountries() {
				this.countriesChanged = true;
			},

			changingStepAction() {

			},

			exportTables () {
				XlsExport.postExportProjectTables(this, this.prepareExportData(1, false, true, this.projectId), successResponse => {
						let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + "_raport.xlsx";
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
						Files.methods.downloadBlobResponse(successResponse, filename);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob"
					});
			},

			async print () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectPrintUrl(this.projectId, this.$route.params.version),
						"projekt.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectPrintUrl(this.projectId),
						"projekt.pdf");
				}
			},

			async printBudget () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectBudgetPrintUrl(this.projectId, this.$route.params.version),
						"budzet.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectBudgetPrintUrl(this.projectId),
						"budzet.pdf");
				}
			},

			async printSchedule () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectTimetablePrintUrl(this.projectId, this.$route.params.version),
						"harmonogram.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectTimetablePrintUrl(this.projectId),
						"harmonogram.pdf");
				}
			},

			async printActivities () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectActivitiesPrintUrl(this.projectId, this.$route.params.version),
						"działania.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getProjectActivitiesPrintUrl(this.projectId),
						"działania.pdf");
				}
			},
		},

		mixins: [
			CostsUtils
		]
	};
</script>

<style scoped>

	.vue-form-generator .field-checklist .listbox {
		max-height: inherit;
		margin-bottom: 10px;
	}
	.vue-form-generator .v-text-field__slot textarea {
		padding: 10px;
		color: #555;
	}
	.stepTitle {
		margin: 20px;
	}

	.div-for-print {
		display: none;
	}
	.field-wrap .container {
		padding: 0;
	}
	.field-wrap .container .layout:only-child {
		margin: 0;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label:before,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label:after {
		color: #555;
		font-size: 13px;
		left: 0!important;
		transform: translateY(50%);
		line-height: 16px;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked~.label,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label {
		background: transparent;
		border: none;
		box-shadow: none;
		position: relative;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .field-wrap label span {
		padding: 0;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .field-wrap label {
		height: auto;
		min-height: 43px;
		display: block;
		color: #555;
		border: 1px solid #ccc;
		border-radius: 4px;
		width: 100%;
		padding: 10px;
		margin: 0 0 .4rem 0;
		cursor: default;
	}
	.form-group > label {
		font-weight: 700;
	}
	.form-group.field-checkbox > label {
		font-weight: 400;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .form-group.field-switch {
		padding-bottom: 0;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked~.handle,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .handle {
		display: none;
	}
	@media print {
		.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot textarea {
			display: none;
		}
		.div-for-print {
			white-space: pre-wrap;
			display: block;
			color: #555;
			border: 1px solid #ccc;
			border-radius: 4px;
			padding: 10px;
			width: 100%;
			min-height: 43px;
			font-size: 13px;
			line-height: 16px;
		}
		/* .field-customTextArea {
			page-break-inside: avoid;
		} */
	}

	.theme--dark th,
	.theme--dark td {
		border: solid 1px white !important;
	}
	.vue-form-generator .form-group:not(:last-of-type) {
		margin-bottom: 0;
	}
	.vue-form-generator .form-group {
		padding-bottom: 0;
		padding-top: 0;
		margin-bottom: 1rem;
	}
	fieldset {
		padding-top: 9px;
	}
	.form-group.disabled.featured.field-input {
		margin-bottom: 12px;
	}
	.field-customTextArea .field-wrap .container .v-textarea {
		padding: 0;
		margin: 0;
	}
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked~.label {
		background-color: transparent!important;
	}
	.offer-signature-table th,
	.offer-signature-table td {
		border: 2px groove rgb(192, 192, 192);
	}

	.form-group label > :first-child {
		display: inline;
	}
	@media screen and (min-width: 960px) {
		.field-customTextArea .field-wrap .container {
			max-width: inherit;
		}
	}
</style>
